// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"205":"8a350ad3","628":"97875d62","678":"8a350ad3"}[chunkId] + ".chunk.css";
};